// extracted by mini-css-extract-plugin
export default {"snippet":"Welcome_snippet--ulX","iconsContainer":"Welcome_iconsContainer--iu_","emailField":"Welcome_emailField--x8g","rulesList":"Welcome_rulesList--K9p"};